<div *ngIf="hasMore" class="btn-group" [sq-action-buttons]="{items: [loadMoreAction], style: buttonsStyle, size: actionsSize, rightAligned: false}"></div>
